import React, { useEffect, useState } from "react";
import axios from "../../axios";
import { toast } from "react-toastify";
import Loader from "../loader/Loader";

const DeleteHowToUseVideo = (props) => {
  const [video, setVideo] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [languages, setLanguages] = useState("al");

  const id = props?.match?.params?.id;

  const language = (lang) => {
    if (lang === "al") setLanguages("al");
    if (lang === "sr") setLanguages("sr");
    if (lang === "en") setLanguages("en");
  };

  useEffect(() => {
    axios
      .get(`how-to-use-videos/${id}`)
      .then((res) => {
        setVideo(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        toast.error("Something went wrong!");
        console.log(err);
        setIsLoading(false);
      });
  }, [id]);

  const handleDelete = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      await axios.delete(`how-to-use-videos/${id}`);
      toast.success("Video has been deleted successfully!");
      window.history.back();
    } catch (err) {
      toast.error("Something went wrong!");
      console.log(err);
      setIsLoading(false);
    }
  };

  const getTitleByLang = () => {
    if (!video) return "";
    if (languages === "al") return video.title_al || video.title || "";
    if (languages === "sr") return video.title_sr || "";
    if (languages === "en") return video.title_en || "";
    return "";
  };

  return (
    <div className="privacy_policy p-5 text-left">
      <div className="page-title">
        <h1>Delete How To Use Video</h1>
      </div>
      {isLoading ? (
        <Loader />
      ) : (
        <form onSubmit={handleDelete}>
          <div className="row ml-2 p-1 mb-5">
            <a
              className={languages === "al" ? "lang-btn-active" : "lang-btn"}
              onClick={() => language("al")}
            >
              Albanian
            </a>
            <a
              className={languages === "sr" ? "lang-btn-active" : "lang-btn"}
              onClick={() => language("sr")}
            >
              Serbian
            </a>
            <a
              className={languages === "en" ? "lang-btn-active" : "lang-btn"}
              onClick={() => language("en")}
            >
              English
            </a>
          </div>

          <input
            type="text"
            value={getTitleByLang()}
            disabled
          />

          <button type="submit">Delete</button>
        </form>
      )}
    </div>
  );
};

export default DeleteHowToUseVideo;

